import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Booking } from '../../interfaces/booking'
import { Price } from '../../interfaces/price'
import { Order, OrderItem} from '../../interfaces/order'
import { DbService } from '../../services/db.service'
import { Subscription } from 'rxjs'
import * as uuid from 'uuid/v1'
import { Resource } from 'src/app/interfaces/resource';
import * as io from 'socket.io-client'
import { Observable, Subject } from 'rxjs'

@Component({
  selector: 'app-pay',
  templateUrl: './pay.component.html',
  styleUrls: ['./pay.component.css']
})
export class PayComponent implements OnInit {

  debug = true
  booking: Booking = <Booking>{}
  payId = ''
  subscription: Subscription
  routeSubscription
  resources = []
  settings = []
  prices: Price[] = []
  swishdialogs = []
  dismiss = 'about:blank'
  showBooking = false
  price = 0
  vat = 0
  logo = ''
  steg = 0
  order: Order
  kvittoText = ''
  fetched = 0

  paySubscription: Subscription
  socket
  private payurl = 'https://dodb.bokad.se:443'

  constructor(public db: DbService, private route: ActivatedRoute) { }

  ngOnInit() {

    this.subscription = this.db.getMessages().subscribe(message => {
      this.messageHandler(message)
    })

    this.paySubscription = this.getMessages().subscribe(message => {
      this.payMessageHandler(message)
    })    

    this.routeSubscription = this.route.params.subscribe(params => {
      //console.log(params);
      this.payId = params.id
      this.db.system = params.system
      //this.getBooking(params.uuid);
    })

    this.db.sendMessage('login', { system: this.db.system, user: 'web', pass: '' })

  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
    this.routeSubscription.unsubscribe()
  }

  payMessageHandler(message) {

    if (message.table == 'payok') {
      this.steg = 41
    }

    if (message.table == 'payfail') {
      this.steg = 31
    }
  }

  messageHandler(message) {

    if (message.action == 'login') { 

      this.fetched = 0

      // Get settings
      this.db.sendMessage('dbm', { 
        cmd: 'find', 
        table: 'settings', 
        condition: { system: this.db.system, name: { $regex: '^web', $options: 'i'} },
        tableSuffix: '' ,
        sort: {},
        limit: 0
      })

      // Get resources
      this.db.sendMessage('dbm', { 
        cmd: 'find', 
        table: 'resources', 
        condition: { system: this.db.system },
        tableSuffix: '' ,
        sort: {},
        limit: 0
      })

      // Get prices
      this.db.sendMessage('dbm', { 
        cmd: 'find', 
        table: 'prices', 
        condition: { system: this.db.system },
        tableSuffix: '' ,
        sort: {},
        limit: 0
      })      

      // Get booking
      this.db.sendMessage('dbm', { 
        cmd: 'find', 
        table: 'bookings', 
        condition: { system: this.db.system, id: this.payId, deleted: false },
        tableSuffix: '' ,
        sort: {},
        limit: 0
      })
      
      // Get swishdialogs
      this.db.sendMessage('dbm', { 
        cmd: 'find', 
        table: 'swishdialogs', 
        condition: { system: this.db.system, idb: this.payId, status: 'PAID' },
        tableSuffix: '' ,
        sort: {},
        limit: 0
      })      

    }

    if (message.table == 'swishdialogs') {
      this.swishdialogs = <any[]>message.data
      //console.log('swd', this.swishdialogs)
      if (this.swishdialogs.length) this.steg = 91
    }    

    if (message.table == 'resources') {
      this.resources = <any[]>message.data
      this.checkFetched(++this.fetched)
    }

    if (message.table == 'prices') {
      this.prices = <any[]>message.data
      this.checkFetched(++this.fetched)
    }

    if (message.table == 'settings') {

      this.settings = <any[]>message.data

      // Get dismiss address
      this.settings.filter(s => s.name == 'webreturn').forEach(s => {
        this.dismiss = s.value
      })   

      // Get receipt text
      this.settings.filter(s => s.name == 'webkvittotext').forEach(s => {
        this.kvittoText = s.value
      })   
      
      // Get logo
      this.settings.filter(s => s.name == 'weblogo').forEach(s => {
        if (s.value.length > 4) {
          this.db.sendMessage('dbm', { 
            cmd: 'find', 
            table: 'files', 
            condition: { system: this.db.system, name: s.value },
            tableSuffix: '' ,
            sort: {},
            limit: 1
          })
        }
      })     

    }

    if (message.table == 'bookings') { 
      if (message.data.length == 1) {
        this.booking = message.data[0]
        this.price = 0
        this.vat = 0
        this.checkFetched(++this.fetched)
      }
    }

    if (message.table == 'files') {
      var files = <any[]>message.data
      if (files.length == 1) this.logo = files[0].data
    }

  }

  checkFetched(counter) {
    if (counter == 3) {
      this.steg = 1
      this.setPrices()
    }
  }

  setPrices() {

    var d = new Date(this.booking.workday)
    var n = d.getDay()
    if (n == 0) n = 7
    n--

    this.booking.bookingItems.forEach(bi => {

      var weekminute = n * 24 * 60 + bi.start;

      var price = 0
      var vat = 0
      
      this.prices.filter(p => p.idResource == bi.idResource).forEach(p => {
        if (weekminute >= p.from_min && weekminute <= p.to_min) {
          price = Math.round(p.price / this.db.getResource(bi.idResource, this.resources).defaultduration * bi.duration);
          var vatperc = p.vat / 100;
          var priceexcl = price / (1 + vatperc);
          vat = Math.round((price - priceexcl) * 100) / 100;
        }
      })
  
      if (price == 0) this.steg = 90
      
      bi.price = price
      bi.vat = vat

      this.price += price
      this.vat += vat

    });

  }  

  getResource(id) {
    
    var ret = ''
    
    this.resources.filter(r => r.id == id).forEach(r => {
      ret = r.name 
    })

    return ret

  }

  getAntal(ci) {

    var ret = ''

    this.resources.filter(r => r.id == ci.idResource).forEach(r => {

      if (+r.confirmationtype == 1 && ci.bookingObjects.length > 0) {
        ret = ci.bookingObjects.length + ' ' + ( ci.bookingObjects.length == 1 ? r.unit : r.unitplural)
      }

      if (+r.confirmationtype == 2 && this.booking.persons > 0) {
        ret = this.booking.persons + ' ' + ( this.booking.persons == 1 ? 'person' : 'personer')
      }

    })

    return ret

  }

  betala() {

    this.steg = 21

    this.order = { 
      id: uuid(),
      idb: this.booking.id,
      workday: this.getToday(), 
      items: [], 
      payed: false, 
      payStatus: 'REQUESTED', 
      contact: { 
        fnamn: this.booking.contact.fnamn, 
        enamn: this.booking.contact.enamn, 
        mobil: this.booking.contact.mobil, 
        epost: this.booking.contact.epost
      }, 
      orderSum: 0, 
      table: '', 
      system: this.db.system,
      kvittoText: this.kvittoText
    }

    var orderSum = 0
    this.booking.bookingItems.forEach(bi => {
      
      var oi: OrderItem = {
        id: uuid(),
        text: this.db.getResource(bi.idResource, this.resources).name,
        price: bi.price,
        vat: bi.vat,
        credited: 0,
        addons: [],
        printer: ''
      }

      this.order.items.push(oi)

      orderSum += bi.price

    })

    this.order.orderSum = orderSum

    this.sendMessage('mo', { cmd: 'pay', order: this.order })

    if (
      this.db.browserInfo.device == 'iphone' ||
      this.db.browserInfo.device == 'android'
    ) window.open("swish://")

  }

  getToday() {
    var today = new Date()
    var y = today.getFullYear()
    var m = today.getMonth() + 1
    var d = today.getDate()
    return y + '-' + m.toString().padStart(2, '0') + '-' + d.toString().padStart(2, '0')
  }

  sendMessage(room, message) {
    if (this.debug) console.log("Sending message: ", message);
    this.socket.emit(room, message); 
  }

  public getMessages() {

    let observable = new Observable(observer => {
      
      if (!this.socket) {
        //console.log('Connecting with token', this.token)
        this.socket = io.connect(this.payurl, { rejectUnauthorized: false, origins: "*" });
      }

      this.socket.on('message', (data) => {
        observer.next(data);
      });

      this.socket.on('login', (data) => {
        observer.next(data);
      });

      this.socket.on('db', (data) => {
        observer.next(data);
      });

      this.socket.on('connect', (data) =>{
        //if (this.debug) console.log("socket connect");
      });

      this.socket.on('reconnect', (data) =>{
        console.log('reconnect', data)
      });

      this.socket.on('connect_error', (data) =>{
        if (this.debug) console.log("connect failed", data);
      }); 

    })
    
    return observable;
  }  

}
